import "../../../assets/fa-icons/css/fontawesome.css";
import "../../../assets/fa-icons/css/sharp-regular.css";
import { ButtonLink } from "../../components/buttons/button-link";
import { FirmCard } from "../../components/firm-card";

interface LogoAndActionButtonsProps {
  anyBranchId: string;
  name: string;
  email: string;
  logoUrl: string;
  logoHighResUrl: string;
  websiteUrl?: string | null;
}

export const LogoAndActionButtons = (props: LogoAndActionButtonsProps) => {
  return (
    <FirmCard
      imageSlot={
        <img
          className="w-full h-full object-contain"
          src={props.logoUrl}
          srcSet={`${props.logoHighResUrl} 2x`}
          alt={`${props.name} logo`}
        />
      }
      actionsSlot={
        <>
          <ButtonLink
            label="Email agent"
            colorVariant="secondary"
            variant="outlined"
            renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-envelope" />}
            href={`mailto:${props.email}`}
          />

          {!!props.websiteUrl && (
            <ButtonLink
              label="Visit agent website"
              colorVariant="secondary"
              variant="outlined"
              renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-arrow-up-right-from-square" />}
              href={props.websiteUrl}
              target="_blank"
            />
          )}

          <ButtonLink
            label="Request a valuation"
            colorVariant="secondary"
            variant="solid"
            renderLeadingIcon={() => <i className="fa-sharp fa-regular fa-chart-line" />}
            href={`/valuations?id=${props.anyBranchId}`}
          />
        </>
      }
    />
  );
};
